export default {"src":"/_next/static/media/2000_gradient.f97d8c2e.svg","height":58,"width":133,"blurWidth":0,"blurHeight":0};